import React, { useState, useContext } from "react";
import {
  TextInput,
  PasswordInput,
  Anchor,
  Paper,
  Title,
  Text,
  Container,
  Button,
} from "@mantine/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/User";
import { showNotification } from "@mantine/notifications";

const Register = () => {
  const history = useHistory();
  const { setIsLoggedIn, setUserInfo } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setsuccess] = useState("");

  const [loading, setLoading] = useState(false);
  const handleRegiser = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    axios
      .post("https://swipett.herokuapp.com/auth/register", {
        username,
        password,
      })
      .then((res) => {
        setsuccess(res.data.message);
        setIsLoggedIn(true);
        setUserInfo({
          username: res.data.user.username,
          avatar: "",
          desc: "",
        });
        localStorage.setItem("token", res.data.token);
        showNotification({
          title: "Account Created Successfully",
          message: `Welcome to Swipet, ${res.data.user.username}  🐱`,
        });

        history.push("/completeprofile");
      })
      .catch((err) => {
        setError(err.response.data.message);
        setLoading(false);
      });
  };
  return (
    <div>
      <Container size={420} my={40}>
        <Title
          align="center"
          sx={(theme) => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          Welcome to Swipet 🐶
        </Title>
        <Text color="dimmed" size="sm" align="center" mt={5}>
          Already an account? {""}
          <Anchor
            size="sm"
            onClick={(event) => {
              event.preventDefault();
              history.push("/login");
            }}
          >
            Sign in
          </Anchor>
        </Text>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          {error && (
            <Text color="red" size="sm" align="left" mt={5}>
              {error}
            </Text>
          )}
          {success && (
            <Text color="green" size="sm" align="left" mt={5}>
              {success}
            </Text>
          )}

          <form
            onSubmit={(e) => {
              handleRegiser(e);
            }}
          >
            <TextInput
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              label="Username"
              placeholder="Username"
              required
            />
            <PasswordInput
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              label="Password"
              placeholder="Password"
              required
              mt="md"
            />
            {loading ? (
              <Button disabled type="submit" fullWidth mt="xl">
                Register
              </Button>
            ) : (
              <Button type="submit" fullWidth mt="xl">
                Register
              </Button>
            )}
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default Register;
